import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "../../context/LanguageContext";

const Line = ({ progress, i, left, right }) => {
  const shift = 30 + i * 12;
  const x1 = useTransform(progress, [0.1, 0.75], [0, -shift]);
  const x2 = useTransform(progress, [0.1, 0.75], [0, shift]);
  return (
    <span className="flex justify-center gap-4 md:gap-8">
      <motion.span style={{ x: x1 }}>{left}</motion.span>
      <motion.span style={{ x: x2 }}>{right}</motion.span>
    </span>
  );
};

export const LargeQuoteSection = () => {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const coinY = useTransform(scrollYProgress, [0.05, 0.85], ["-140%", "160%"]);
  const authorOpacity = useTransform(scrollYProgress, [0.55, 0.7], [0, 1]);

  return (
    <section ref={ref} className="relative px-6 md:px-14 py-32 md:py-52 overflow-hidden" data-testid="large-quote-section">
      <motion.div
        style={{ y: coinY }}
        className="absolute left-1/2 top-1/2 -translate-x-1/2 rounded-full"
        aria-hidden="true"
      >
        <div
          className="rounded-full"
          style={{
            width: "clamp(60px, 9vw, 150px)",
            height: "clamp(60px, 9vw, 150px)",
            background: "radial-gradient(circle at 35% 30%, #E8CE8F, #C5A059 55%, #7a5f2c)",
            boxShadow: "0 0 80px rgba(197,160,89,0.35)",
          }}
        />
      </motion.div>

      <blockquote className="relative z-10 font-serif italic text-2xl md:text-5xl leading-snug text-zinc-100 text-center">
        {t.quote.lines.map(([l, r], i) => (
          <Line key={i} progress={scrollYProgress} i={i} left={l} right={r} />
        ))}
        <motion.p style={{ opacity: authorOpacity }} data-testid="quote-author" className="mt-14 not-italic font-sans text-[0.7rem] uppercase tracking-[0.4em] text-[#C5A059]">
          {t.quote.author}
        </motion.p>
      </blockquote>
    </section>
  );
};
